module.exports = __webpack_public_path__ + "img/10-fourImg.1b95e1e4.png";